import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getDefaultPathForUser, useAuth } from "../context/AuthContext";
import { getApiErrorMessage } from "../api";
import ThemeToggle from "../components/ThemeToggle";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) {
    const from = location.state?.from;
    const target =
      from && from !== "/login" ? from : getDefaultPathForUser(user);
    return <Navigate to={target} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const data = await login(username.trim(), password);
      const from = location.state?.from;
      const target =
        from && from !== "/login" ? from : getDefaultPathForUser(data);
      navigate(target, { replace: true });
    } catch (err) {
      setError(getApiErrorMessage(err, "Неверный логин или пароль"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>VITA</h1>
          <p>Вход в платформу</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}

          <label className="login-label">
            Логин
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              disabled={submitting}
            />
          </label>

          <label className="login-label">
            Пароль
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              disabled={submitting}
            />
          </label>

          <button type="submit" className="login-button" disabled={submitting}>
            {submitting ? "Вход..." : "Войти"}
          </button>
        </form>

        <div className="login-footer">
          <span>Тема оформления</span>
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
}
